import Navbar from "./components/Navbar";
import "./App.css";
import TypeWriter from "./components/TypeWriter";
import AutoScroll from "./components/AutoScroll";

const projects = [
  {
    title: "Coco Search",
    description: "Instant eBay notifications on items you're interested in.",
    link: "https://cocosearch.co.uk",
    image: process.env.PUBLIC_URL + "/screenshots/cocosearch.png",
    type: "project",
  },
  {
    title: "Product Search",
    description:
      "A smart e-commerce search engine spanning thousands of retailers.",
    image: process.env.PUBLIC_URL + "/screenshots/product_search.png",
    link: process.env.PUBLIC_URL + "/TTDS_Report.pdf",
    type: "report",
  },
  {
    title: "AI Ethics Thesis Platform",
    description: "Interactive database for AI ethics case studies",
    link: "https://ethicsdb2.web.app/",
    image: process.env.PUBLIC_URL + "/screenshots/ethicsdb.png",
    type: "project",
  },
];

const currentProjects = [
  {
    title: "InBetments",
    description:
      "Football match outcome prediction system, currently with 53% accuracy. In development.",
    image: process.env.PUBLIC_URL + "screenshots/football_predictor.png",
    status: "active-development",
    features: [
      "Various prediction models, match outcome, over/under, and more",
      "Interactive front end",
      "Make informed bets with confidence",
    ],
  },
];

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        {/* Hero Section */}
        <section id="about" className="section hero">
          <div className="hero-content">
            <h2>Software Engineer . ML Engineer</h2>
            <p className="lead">
              <TypeWriter
                texts={[
                  "Building machine learning solutions across sports, e-commerce, and more.",
                ]}
                speed={50}
              />
            </p>
            <a
              href="mailto:oscar.alberigo@example.com?subject=Collaboration%20Opportunity&body=Hi%20Oscar%2C%0D%0A%0D%0AI%20wanted%20to%20discuss..."
              className="cta-button"
            >
              Let's Collaborate
            </a>
            <div className="scroll-indicator">
              <div className="arrow"></div>
            </div>
          </div>
          <div className="hero-image">
            <img
              src={
                process.env.PUBLIC_URL +
                "/screenshots/portfolio_picture_zoomed.png"
              }
              alt="Oscar Alberigo Portrait"
              className="profile-image"
            />
          </div>
        </section>

        {/* Projects Grid */}
        <section id="work" className="section dark-bg">
          <h2 className="section-title">Featured Projects</h2>
          <AutoScroll>
            <div className="projects-grid">
              {projects.map((project, index) => (
                <div key={index} className="project-card">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                    onError={(e) => {
                      e.target.style.display = "none"; // Hide broken images
                    }}
                  />
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener"
                      className="project-link"
                    >
                      {project.type === "project"
                        ? "View Project →"
                        : "Read More →"}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </AutoScroll>
        </section>

        {/* Current Project */}
        <section id="current-work" className="section highlight-section">
          <h2 className="section-title">Current Focus Project</h2>
          <div className="current-project-grid">
            {currentProjects.map((project, index) => (
              <div key={index} className="current-project-card">
                <img
                  src={project.image}
                  alt={project.title}
                  className="current-project-image"
                />
                <div className="project-details">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <ul className="feature-list">
                    {project.features.map((feature, fIndex) => (
                      <li key={fIndex} className="feature-item">
                        <span className="feature-icon">⚙️</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="status-badge">{project.status}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Development Approach */}
        <section id="approach" className="section">
          <h2 className="section-title">Development Philosophy</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>MVP Design</h3>
              <p>
                Rapid prototyping of core functionality with clean architecture
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Feedback Loops</h3>
              <p>
                Iterative improvements based on user testing and peer reviews
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Agile Refinement</h3>
              <p>
                Continuous deployment with user-driven feature prioritization
              </p>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section id="gallery" className="section dark-bg">
          <h2 className="section-title">Beyond Code</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/coolpics/62d80059-9291-4706-88e4-021b520ade72.jpg"
                }
                alt="Andora Fireworks 2023"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/coolpics/a75019cb-bf04-4c6f-bb59-207971371062.jpg"
                }
                alt="Me n mum"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/coolpics/d6d93681-dbf7-416d-9b1e-40655cd0adb3.jpg"
                }
                alt="Fishing in Greece"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/coolpics/f0ec15a2-00f6-4dfb-8a10-76da84f67b1f.jpg"
                }
                alt="Boat trip 2023"
                className="gallery-image"
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;
